import React from 'react';
import { useSelector } from 'react-redux';

import { selectCallCenterWorkTime, selectCurrentCityPhone } from '@r1-frontend/entities/stores/city/selectors';

import * as ST from './styled';

const PhoneInfo = () => {
    const { href, hasPhoneData, callCenter } = useSelector(selectCurrentCityPhone);
    const callCenterWorkTime = useSelector(selectCallCenterWorkTime);

    if (!callCenter || !hasPhoneData) {
        return null;
    }

    return (
        <ST.CallCenterBlock>
            <ST.CityPhone
                href={href}
                className='js-calltouch-phone'
                data-test='phone'
            >
                {callCenter}
            </ST.CityPhone>
            {callCenterWorkTime && <ST.CallCenterInfo dangerouslySetInnerHTML={{ __html: callCenterWorkTime }}/>}
        </ST.CallCenterBlock>
    );
};

export default PhoneInfo;
